/**
 * @file Here.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2021
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Here Management Service
 * @class
 */
class Here extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    // this.request = new Request({environment: 'local', tag: 'here'})
    this.request = new Request({tag: 'here'})
  }

  async calculateIsoline (options = {}) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/isoline`
      this.request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
  async calculateRoute (options = {}) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/route`
      this.request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
  async createBuffer (options = {}) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/buffer`
      this.request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
  /**
   * Delete user draw
   *
   * @async
   * @function delete
   * @param {String} requestId - Request Id
   * @return {Promise<string>} The data from the URL.
   */
  async delete (requestId) {
    return new Promise((resolve, reject) => {
      if (typeof requestId === 'undefined') reject(new Error('Esperado o identificador do objeto'))
      const endPoint = `/api/userdraw/${requestId}`
      this.request.delete(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  async getGeocode (options = {}) {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/geocode`
      this.request.post(endPoint, options, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }

  /**
   * Get reverse geocode
   * @param at { String } A LngLat object represents a given longitude and latitude coordinate, measured in degrees.
   * @param lang { String } Select the language to be used for result rendering from a list of BCP 47 compliant language codes.
   * @param types { String } - The following result type filter values: address, street, area or city.
   * @returns {Promise<*>}
   */
  async getReverseGeocode (at, lang = "en-US", types= "address") {
    return new Promise((resolve, reject) => {
      const endPoint = `/api/revgeocode?at=${at}&lang=${lang}&types=${types}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(res => resolve(res))
        .catch(() => reject)
    })
  }
}

export { Here }
